<template>
  <div>
    <!-- ALL SUGGESTIONS -->
    <div v-if="mode == 3">
      <span>{{ systemFound }}</span>
      <span class="primary--text">{{ subCategoriesSuggestionsCount }}</span>
      <span class="black--text">משרות נוספות בתחום</span>

      <nuxt-link
        v-for="(suggestion, index) in allSuggestions.subCategory"
        :key="index"
        :to="`/jobs/subcat/${allSuggestions.subCategory[index].Item.Code}`"
      >
        <span class="primary--text">{{ allSuggestions.subCategory[index].Item.NameInHebrew }}</span>
        <span v-if="notLastElement(allSuggestions.subCategory, index)" class="no-underline-gap">,</span>
      </nuxt-link>

      <span>,</span>
      <span class="primary--text">{{ allSuggestions.category[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות בקטגוריה</span>
      <nuxt-link :to="`/jobs/cat${categoryLink}`">
        <span class="primary--text">{{ allSuggestions.category[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span>{{ andFound }}</span>
      <span class="primary--text">{{ allSuggestions.region[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות באזור</span>
      <nuxt-link :to="`/jobs/area/${regionLink}`">
        <span class="primary--text">{{ allSuggestions.region[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">.</span>
      <span class="black--text">{{ expandSearch }}</span>
      <nuxt-link :to="`/jobs/area/${zoneLink}`">
        <span class="primary--text">{{ allSuggestions.zone[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">?</span>
    </div>

    <!-- CATEGORY AND ZONE -->
    <div v-else-if="mode == 0">
      <span>{{ systemFound }}</span>
      <span class="primary--text">{{ allSuggestions.category[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות בקטגוריה</span>
      <nuxt-link :to="`/jobs/cat${categoryLink}`">
        <span class="primary--text">{{ allSuggestions.category[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span>,</span>
      <span>{{ andFound }}</span>
      <span class="primary--text">{{ allSuggestions.zone[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות באזור</span>
      <nuxt-link :to="`/jobs/area/${zoneLink}`">
        <span class="primary--text">{{ allSuggestions.zone[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">.</span>
    </div>

    <!-- SUB CATEGORY, CATEGORY AND ZONE -->
    <div v-else-if="mode == 2">
      <span>{{ systemFound }}</span>
      <span class="primary--text">{{ subCategoriesSuggestionsCount }}</span>
      <span class="black--text">משרות נוספות בתחום</span>

      <nuxt-link
        v-for="(suggestion, index) in allSuggestions.subCategory"
        :key="index"
        :to="`/jobs/subcat/${allSuggestions.subCategory[index].Item.Code}`"
      >
        <span class="primary--text">{{ allSuggestions.subCategory[index].Item.NameInHebrew }}</span>
        <span v-if="notLastElement(allSuggestions.subCategory, index)" class="no-underline-gap">,</span>
      </nuxt-link>

      <!-- </nuxt-link> -->
      <span>,</span>
      <span class="primary--text">{{ allSuggestions.category[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות בקטגוריה</span>
      <nuxt-link :to="`/jobs/cat/${categoryLink}`">
        <span class="primary--text">{{ allSuggestions.category[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span>{{ andFound }}</span>
      <span class="primary--text">{{ allSuggestions.zone[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות באזור</span>
      <nuxt-link :to="`/jobs/area/${zoneLink}`">
        <span class="primary--text">{{ allSuggestions.zone[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">.</span>
    </div>

    <!-- CATEGORY AND REGION (adds zone) -->
    <div v-else-if="mode == 1">
      <span>{{ systemFound }}</span>
      <span class="primary--text">{{ allSuggestions.category[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות בקטגוריה</span>
      <nuxt-link :to="`/jobs/cat${categoryLink}`">
        <span class="primary--text">{{ allSuggestions.category[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span>{{ andFound }}</span>
      <span class="primary--text">{{ allSuggestions.region[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות באזור</span>
      <nuxt-link :to="`/jobs/area/${regionLink}`">
        <span class="primary--text">{{ allSuggestions.region[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">.</span>
      <span class="black--text">{{ expandSearch }}</span>
      <nuxt-link :to="`/jobs/area/${zoneLink}`">
        <span class="primary--text">{{ allSuggestions.zone[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">?</span>
    </div>

    <!-- SHOW_WITHOUT_CATEGORY -->
    <div v-else-if="mode == 4">
      <span>{{ systemFound }}</span>
      <span class="primary--text">{{ subCategoriesSuggestionsCount }}</span>
      <span class="black--text">משרות נוספות בתחום</span>

      <nuxt-link
        v-for="(suggestion, index) in allSuggestions.subCategory"
        :key="index"
        :to="`/jobs/subcat/${allSuggestions.subCategory[index].Item.Code}`"
      >
        <span class="primary--text">{{ allSuggestions.subCategory[index].Item.NameInHebrew }}</span>
        <span v-if="notLastElement(allSuggestions.subCategory, index)" class="no-underline-gap">,</span>
      </nuxt-link>

      <span>{{ andFound }}</span>
      <span class="primary--text">{{ allSuggestions.region[0].JobCount.toLocaleString() }}</span>
      <span class="black--text">משרות נוספות באזור</span>
      <nuxt-link :to="`/jobs/area/${regionLink}`">
        <span class="primary--text">{{ allSuggestions.region[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">.</span>
      <span class="black--text">{{ expandSearch }}</span>
      <nuxt-link :to="`/jobs/area/${zoneLink}`">
        <span class="primary--text">{{ allSuggestions.zone[0].Item.NameInHebrew }}</span>
      </nuxt-link>
      <span class="black--text">?</span>
    </div>
  </div>
</template>

<script>
import drushim_lodash from 'lodash'
import { t } from '@/store/modules/homeDrushim/constantsContent'

const CAT_AND_ZONE = 0
const CAT_AND_REGION = 1
const SUBCAT_AND_ZONE = 2
const SHOW_ALL = 3
const SHOW_WITHOUT_CATEGORY = 4

export default {
  props: {
    allSuggestions: {
      type: Object
    },

    categoryLink: {
      type: Number
    },

    subCategoryLink: {
      type: Number
    },

    zoneLink: {
      type: String
    },

    regionLink: {
      type: Number
    }
  },

  data() {
    return {
      catAndZone: false,
      catAndRegion: false,
      subcatAndZone: false,
      showAll: false,
      subcatAndZoneNoCategory: false,
      systemFound: t(`titles.suggestions.systemFound`),
      commaFound: t(`titles.suggestions.commaFound`),
      andFound: t(`titles.suggestions.andFound`),
      expandSearch: t(`titles.suggestions.expandSearch`),
      exactMatch: t(`titles.suggestions.exactMatch`)
    }
  },

  mounted() {
    this.currCase()
  },

  computed: {
    isCategory() {
      return !drushim_lodash.isEmpty(this.allSuggestions.category) ? true : false
    },

    isSubCategory() {
      return !drushim_lodash.isEmpty(this.allSuggestions.subCategory) ? true : false
    },

    isRegion() {
      return !drushim_lodash.isEmpty(this.allSuggestions.region) ? true : false
    },

    isZone() {
      return !drushim_lodash.isEmpty(this.allSuggestions.zone) ? true : false
    },

     subCategoriesSuggestionsCount() {
      return drushim_lodash.reduce(
        this.allSuggestions.subCategory,
        function(sum, e) {
          return sum + e.JobCount
        },
        0
      )
    },

    mode() {
      let res
      if (this.catAndZone) {
        res = CAT_AND_ZONE
      } else if (this.catAndRegion) {
        res = CAT_AND_REGION
      } else if (this.subcatAndZone) {
        res = SUBCAT_AND_ZONE
      } else if (this.showAll) {
        res = SHOW_ALL
      } else if (this.subcatAndZoneNoCategory) {
        res = SHOW_WITHOUT_CATEGORY
      }
      return res
    },


  },

  methods: {
    currCase() {
      //category and zone only
      if (
        this.isCategory &&
        !this.isSubCategory &&
        !this.isRegion &&
        this.isZone
      ) {
        this.catAndZone = true
      }
      //category and region(city) adds zone(usually)
      else if (
      (this.isCategory &&
        !this.isSubCategory &&
        this.isRegion &&
        !this.isZone) || (this.isCategory &&
        !this.isSubCategory &&
        this.isRegion &&
        this.isZone)
      ) {
        this.catAndRegion = true
      }
      //subcat and zone adds category
      else if (this.isSubCategory && this.isCategory && !this.isRegion && this.isZone) {
        this.subcatAndZone = true
      } else if (
        this.isCategory &&
        this.isSubCategory &&
        this.isRegion &&
        this.isZone
      ) {
        this.showAll = true
      }
      else if (this.isSubCategory && !this.isCategory && this.isRegion && this.isZone) {
        this.subcatAndZoneNoCategory = true
      }
    },

    notLastElement(object, index) {
      return (drushim_lodash.size(object)-1 != index) ? true : false
    }
  },

  beforeDestroy() {
    this.catAndZone = false
    this.catAndRegion = false
    this.subcatAndZone = false
    this.showAll = false
  }
}
</script>


<style scoped>
.no-underline-gap {
  text-decoration: none !important;
  padding: 2px;
}
</style>
